import React, { useState, useLayoutEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  IconButton,
  useTheme,
} from "@mui/material";

import { tokens } from "../../../../../theme";

import { ReactComponent as NextVector } from "../../../../Scheduler/Statics/NextVV.svg";
import { ReactComponent as BackVector } from "../../../../Scheduler/Statics/BackVV.svg";

import moment from "jalali-moment";

const MonthSlider = ({ setMainBody }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // برای مدیریت تاریخ
  const [selectedDate, setSelectedDate] = useState(
    moment().locale("fa").startOf("jMonth")
  );

  useLayoutEffect(() => {
    setMainBody((prevBody) => ({
      ...prevBody,

      // خروجی برای API با اعداد انگلیسی
      date: selectedDate
        .clone()
        .locale("en")
        .format("jYYYY/jMM/jDD"),
    }));
  }, [selectedDate, setMainBody]);

  const sxStyle = {
    fontFamily: "yekan !important",
    borderRadius: "4px",
    width: "100%",
    textAlign: "center",
    padding: "8px",

    "& .MuiFormLabel-root": {
      color: colors.grey[100],
    },
  };

  const handlePreviousMonth = () => {
    setSelectedDate((prev) =>
      prev.clone().subtract(1, "jMonth")
    );
  };

  const handleNextMonth = () => {
    setSelectedDate((prev) =>
      prev.clone().add(1, "jMonth")
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton onClick={handlePreviousMonth}>
        <BackVector />
      </IconButton>

      <FormControl sx={sxStyle}>
        <TextField
          disabled
          value={
            selectedDate
              .clone()
              .locale("fa")
              .format("MMMM YYYY")
          }
          size="small"
          InputProps={{
            readOnly: true,
            style: {
              textAlign: "center",
              cursor: "default",
            },
          }}
        />
      </FormControl>

      <IconButton onClick={handleNextMonth}>
        <NextVector />
      </IconButton>
    </Box>
  );
};

export default MonthSlider;